<div class="h-100 d-flex flex-column">
    <app-breadcrumb></app-breadcrumb>

    <div class="card mb-0 mt-3 flex-grow-1">
        <div class="card-body flex-column flex-nowrap">
            <div class="row">              
                <div class="col-auto">
                    <select class="form-control form-control-sm"
                        [(ngModel)]="selectedYear"
                        (ngModelChange)="changeYear($event)">
                        <option *ngFor="let item of listYear;" [ngValue]="item">{{item}} 년</option>
                    </select>
                </div>
                <div class="col-auto">
                    <select class="form-control form-control-sm"
                        [(ngModel)]="selectedMonth"
                        (ngModelChange)="changeMonth($event)">
                        <option *ngFor="let item of listMonth;" [ngValue]="item">{{item}} 월</option>
                    </select>
                </div>
                <div class="col-auto">
                    <select class="form-control form-control-sm"
                        [(ngModel)]="selectedMinDrive"
                        (ngModelChange)="changeMinDrive($event)">
                        <option [ngValue]="0">전체</option>
                        <option *ngFor="let item of listMinDrive;" [ngValue]="item">운행시간 {{item}} 분 미만 제외</option>
                    </select>
                </div>
                <div class="col-auto">
                    <select class="form-control form-control-sm"
                        [(ngModel)]="selectedMinRest"
                        (ngModelChange)="changeMinRest($event)">
                        <option [ngValue]="0">전체</option>
                        <option *ngFor="let item of listMinRest;" [ngValue]="item">대기시간 {{item}} 분 미만 제외</option>
                    </select>
                </div>
                <div class="col"></div>
                <div class="col-auto">
                  <button type="button" class="btn btn-sm btn-info" (click)="clickSearch()">
                    <i class="fas fa-sync mr-1"></i>
                    불러오기
                  </button>
                </div>
                <div class="col-auto">
                    <button type="button" class="btn btn-sm btn-outline-success"
                        (click)="exportExcel()">
                        <i class="fas fa-file-excel"></i>
                        <span class="ml-1">엑셀출력</span>
                    </button>
                </div>
            </div>
            <div class="overflow-auto position-absolute m-3"
                style="height: calc(100% - 4.8rem);width: calc(100% - 2rem);left: 0px;bottom: 0px;">
                <table class="table table-sm table-hover align-items-center text-nowrap mb-0">
                    <thead>
                        <tr class="text-center">
                            <th colspan="8">
                                운전자정보
                            </th>
                            <th colspan="4" class="border-left border-right">
                                운행정보
                            </th>
                            <th [attr.colspan]="maxDriveCnt * 2">
                                운행 및 휴게시간 내역(분)
                            </th>
                        </tr>
                        <tr class="text-center">
                            <th rowspan="2" class="border-right">
                                업체코드
                            </th>
                            <th rowspan="2" class="border-right">
                                운수종사자ID
                            </th>
                            <th rowspan="2" class="border-right">
                                업체명
                            </th>
                            <th rowspan="2" class="border-right">
                                생년월일
                            </th>
                            <th rowspan="2" class="border-right">
                                성명
                            </th>
                            <th rowspan="2" class="border-right">
                                입사일자
                            </th>
                            <th rowspan="2" class="border-right">
                                운송구분
                            </th>
                            <th rowspan="2" class="border-right">
                                시작일자
                            </th>
                            <th rowspan="2" class="border-right">
                                시작시간
                            </th>
                            <th rowspan="2" class="border-right">
                                종료일자
                            </th>
                            <th rowspan="2" class="border-right">
                                종료시간
                            </th>
                            <ng-template ngFor let-item [ngForOf]="listDriveCnt">
                                <th colspan="2" class="small border-left">
                                    {{item + 1}}회
                                </th>
                            </ng-template>
                        </tr>
                        <tr class="text-center small">
                            <ng-template ngFor let-item [ngForOf]="listDriveCnt">
                                <th class="border-left">
                                    운행(분)
                                </th>
                                <th>
                                    휴식(분)
                                </th>
                            </ng-template>
                        </tr>
                    </thead>                    
                    <tbody>
                        <ng-container *ngFor="let itemRow of listRow;">
                            <tr class="text-nowrap text-center">
                                <td>
                                    {{itemRow.etas_eid}}
                                </td>
                                <td>
                                    {{itemRow.drv_kotsa_driver_id}}
                                </td>
                                <td>
                                    {{itemRow.company_nm}}
                                </td>
                                <td>
                                    {{itemRow.user_birth_dt | filterDateTime:'yyyyMMdd'}}
                                </td>
                                <td>
                                    {{itemRow.user_nm}}
                                </td>
                                <td>
                                    {{itemRow.user_hire_dt | filterDateTime:'yyyyMMdd'}}
                                </td>
                                <td>
                                    {{itemRow.dtg_car_type_nm}}
                                </td>
                                <!-- 시작일자 -->
                                <td>
                                    {{itemRow.dtg_reg_dt_from | filterDateTime:'yyyyMMdd'}}
                                </td>
                                <td>
                                    {{itemRow.dtg_reg_dt_from | filterDateTime:'HHmm'}}
                                </td>
                                <!-- 종료일자 -->
                                <td>
                                    {{itemRow.dtg_reg_dt_to | filterDateTime:'yyyyMMdd'}}
                                </td>
                                <td>
                                    {{itemRow.dtg_reg_dt_to | filterDateTime:'HHmm'}}
                                </td>

                                <!-- 회차별 정보 -->
                                <ng-container *ngFor="let itemCnt of listDriveCnt;let idxCnt = index;">
                                    <ng-container *ngIf="(itemRow.getDriveTime(itemCnt)>0);else durDrive">
                                        <td class="border-left bg-light"
                                            role="button"
                                            placement="top"
                                            data-html="true"
                                            [ngbTooltip]="tripInfo"
                                            container="body">
                                            <div>
                                                {{itemRow.getDriveTime(itemCnt) | number}}
                                            </div>
                                            <ng-template #tripInfo>
                                                <div [innerHtml]="itemRow.getTxtDrive(itemCnt)"></div>                                                
                                            </ng-template>
                                        </td>
                                    </ng-container>
                                    <ng-template #durDrive>
                                        <td 
                                        [ngClass]="{'alert alert-danger': itemRow.getDriveTime(itemCnt)<0}"
                                        class="border-left">
                                            <div>
                                                {{itemRow.getDriveTime(itemCnt) | number}}
                                            </div>
                                        </td>
                                    </ng-template>

                                    <ng-container *ngIf="(itemRow.getRestTime(itemCnt)>0);else restDrive">
                                        <td class="border-left bg-light"
                                            role="button"
                                            placement="top"
                                            data-html="true"
                                            [ngbTooltip]="restInfo"
                                            container="body">
                                            <div>
                                                {{itemRow.getRestTime(itemCnt) | number}}
                                            </div>
                                            <ng-template #restInfo>
                                                <div [innerHtml]="itemRow.getTxtRest(itemCnt)"></div>
                                            </ng-template>
                                        </td>
                                    </ng-container>
                                    <ng-template #restDrive>
                                        <td 
                                            [ngClass]="{'bg-light': itemRow.getRestTime(itemCnt)==0 && itemRow.getDriveTime(itemCnt)>0}"
                                            class="border-left">
                                            <div>
                                                {{itemRow.getRestTime(itemCnt) | number}}
                                            </div>
                                        </td>
                                    </ng-template>
                                </ng-container>
                            </tr>
                        </ng-container>
                    </tbody>
                </table>    
            </div>
        </div>
    </div>
</div>
